// Curated infinite-series and limit identities for the homepage math carousel.
// `accent` drives canvas animations; `text_accent` is a lighter harmonious tint for readable math.

export const INFINITE_MATH_SLIDES = [
    {
        id: 'power-tower',
        label: 'Infinite Power Tower',
        accent: '#2cbb5d',
        text_accent: '#b8ffe0',
        latex: 'e^x = \\left(e^{1/e}\\right)^{\\left(e^{1/e}\\right)^{\\left(e^{1/e}\\right)^{\\cdot^{\\cdot^{\\cdot^{x}}}}}}',
        caption: 'Tetration converges when the base is e^{1/e}',
        animation: 'tower',
    },
    {
        id: 'geometric',
        label: 'Geometric Series',
        accent: '#38bdf8',
        text_accent: '#e0f7ff',
        latex: '\\sum_{n=0}^{\\infty} x^n = \\frac{1}{1-x}, \\quad |x| < 1',
        caption: 'Infinite sum collapses into a closed rational form',
        animation: 'converge',
    },
    {
        id: 'euler-e',
        label: "Euler's e",
        accent: '#a78bfa',
        text_accent: '#ede9fe',
        latex: 'e = \\sum_{n=0}^{\\infty} \\frac{1}{n!} = 1 + 1 + \\frac{1}{2!} + \\frac{1}{3!} + \\cdots',
        caption: 'Factorial decay makes the series converge rapidly',
        animation: 'factorial',
    },
    {
        id: 'basel',
        label: 'Basel Problem',
        accent: '#f472b6',
        text_accent: '#ffe4f0',
        latex: '\\sum_{n=1}^{\\infty} \\frac{1}{n^2} = \\frac{\\pi^2}{6}',
        caption: 'Euler linked squares of harmonics to pi-squared',
        animation: 'harmonic',
    },
    {
        id: 'leibniz',
        label: 'Leibniz Series',
        accent: '#34d399',
        text_accent: '#ccfbf1',
        latex: '\\frac{\\pi}{4} = \\sum_{n=0}^{\\infty} \\frac{(-1)^n}{2n+1}',
        caption: 'Alternating odd reciprocals march toward pi over four',
        animation: 'alternate',
    },
    {
        id: 'golden-phi',
        label: 'Golden Ratio',
        accent: '#fbbf24',
        text_accent: '#fff7d6',
        latex: '\\varphi = 1 + \\cfrac{1}{1 + \\cfrac{1}{1 + \\cfrac{1}{1 + \\ddots}}}',
        caption: 'Nested fractions converge to the golden ratio',
        animation: 'nested',
    },
    {
        id: 'nested-radical',
        label: 'Nested Radical',
        accent: '#60a5fa',
        text_accent: '#e8f3ff',
        latex: '\\sqrt{2 + \\sqrt{2 + \\sqrt{2 + \\cdots}}} = 2',
        caption: 'Self-similar radicals stabilize at an exact integer',
        animation: 'radical',
    },
    {
        id: 'riemann-zeta',
        label: 'Riemann Zeta',
        accent: '#fb7185',
        text_accent: '#ffe8ec',
        latex: '\\zeta(s) = \\sum_{n=1}^{\\infty} \\frac{1}{n^s}, \\quad \\Re(s) > 1',
        caption: 'Prime structure is encoded in this infinite sum',
        animation: 'orbit',
    },
    {
        id: 'taylor-exp',
        label: 'Taylor Expansion',
        accent: '#4ade80',
        text_accent: '#dcfce7',
        latex: 'e^x = \\sum_{n=0}^{\\infty} \\frac{x^n}{n!}',
        caption: 'Polynomial layers approximate smooth exponential growth',
        animation: 'polynomial',
    },
];
